import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "@themesberg/react-bootstrap";
import { useCookies } from "react-cookie";

import { autoCreatePeriods } from "../../../../../controller/api/__classic__/input";

const REGION_OPTIONS = [
  { value: "MN", label: "Miền Nam" },
  { value: "MT", label: "Miền Trung" },
  { value: "MB", label: "Miền Bắc" },
];

const DEFAULT_DAYS_AHEAD = 2;
const MIN_DAYS_AHEAD = 1;
const MAX_DAYS_AHEAD = 30;

const AutoCreatePeriodPopup = ({
  show,
  onHide,
  onCreated,
  defaultRegion = "MN",
}) => {
  const [cookies] = useCookies(["lottmekong"]);
  const [region, setRegion] = useState(defaultRegion);
  const [daysAhead, setDaysAhead] = useState(String(DEFAULT_DAYS_AHEAD));
  const [isCreating, setIsCreating] = useState(false);

  const parsedDaysAhead = Number(daysAhead);
  const isDaysAheadInvalid =
    daysAhead === "" ||
    !Number.isInteger(parsedDaysAhead) ||
    parsedDaysAhead < MIN_DAYS_AHEAD ||
    parsedDaysAhead > MAX_DAYS_AHEAD;

  useEffect(() => {
    if (show) {
      setRegion(defaultRegion || "MN");
      setDaysAhead(String(DEFAULT_DAYS_AHEAD));
    }
  }, [show, defaultRegion]);

  const handleSubmit = async () => {
    if (isDaysAheadInvalid) {
      return;
    }

    setIsCreating(true);
    try {
      const result = await autoCreatePeriods(
        cookies.lottmekong,
        parsedDaysAhead,
        region,
      );

      if (result && result.success) {
        alert(
          `✅ ${result.message || "Tạo kỳ thành công"}\n\nĐã tạo: ${
            result.count || 0
          } kỳ\nBỏ qua: ${result.skipped || 0} kỳ`,
        );
        if (onCreated) {
          onCreated();
        }
        if (onHide) {
          onHide();
        }
        return;
      }

      alert(`❌ Lỗi: ${result?.error || "Không thể tạo kỳ mở thưởng"}`);
    } catch (error) {
      console.error("autoCreatePeriods error:", error);
      alert(`❌ Lỗi: ${error.message || "Không thể tạo kỳ mở thưởng"}`);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      aria-labelledby="auto-create-period-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="auto-create-period-modal">Tạo nhanh kỳ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="auto-create-period-region">
            <Form.Label>Khu vực</Form.Label>
            <Form.Select
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            >
              {REGION_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="auto-create-period-days">
            <Form.Label>Số ngày tạo</Form.Label>
            <Form.Control
              type="number"
              min={MIN_DAYS_AHEAD}
              max={MAX_DAYS_AHEAD}
              step="1"
              value={daysAhead}
              onChange={(e) => setDaysAhead(e.target.value)}
              isInvalid={isDaysAheadInvalid}
              disabled={isCreating}
            />
            <Form.Control.Feedback type="invalid">
              Vui lòng nhập số nguyên từ {MIN_DAYS_AHEAD} đến {MAX_DAYS_AHEAD}.
            </Form.Control.Feedback>
          </Form.Group>
          <div className="text-muted small">
            {isDaysAheadInvalid
              ? `Nhập số ngày muốn tạo (tối đa ${MAX_DAYS_AHEAD} ngày).`
              : `Hệ thống sẽ tự động tạo kỳ mở thưởng cho ${parsedDaysAhead} ngày tiếp theo.`}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isCreating}>
          Đóng
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={isCreating || isDaysAheadInvalid}
        >
          {isCreating ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Đang tạo...
            </>
          ) : (
            "Tạo kỳ"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AutoCreatePeriodPopup;
